import { URLS } from "constants/urls";
import apiRequests from "utils/apiRequests";

export const getUserLogoutRequest = () => apiRequests.get(URLS.LOGOUT);

export const getPageVisits = () => apiRequests.get(URLS.PAGE_VISITS);
